(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nmh-countdown"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.custom-countdown-section');

    if (!section) return;

    const hourInput = parseInt(section.dataset.hours || '0');
    const minInput = parseInt(section.dataset.minutes || '0');
    const secInput = parseInt(section.dataset.seconds || '0');

    const totalMsInput = (hourInput * 60 * 60 + minInput * 60 + secInput) * 1000;
    let endTime = Date.now() + totalMsInput;

    const hourEl = document.getElementById('custom-hour');
    const minEl = document.getElementById('custom-minute');
    const secEl = document.getElementById('custom-second');

    function updateCountdown() {
      const now = Date.now();
      let distance = endTime - now;

      if (distance <= 0) {
        // Restart the timer
        endTime = Date.now() + totalMsInput;
        distance = endTime - Date.now();
      }

      const h = Math.floor(distance / (1000 * 60 * 60));
      const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const s = Math.floor((distance % (1000 * 60)) / 1000);

      hourEl.textContent = String(h).padStart(2, '0');
      minEl.textContent = String(m).padStart(2, '0');
      secEl.textContent = String(s).padStart(2, '0');
    }

    setInterval(updateCountdown, 1000);
    updateCountdown(); // Initial call
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nmh-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const faqItems = document.querySelectorAll('.custom-faq-item');

    faqItems.forEach((item) => {
      item.querySelector('.custom-faq-question').addEventListener('click', () => {
        item.classList.toggle('open');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nmh-testmo"] && !Shopify.designMode) return;
  try {
    
  // Add GlideJS CDN
  const glideCSS = document.createElement('link');
  glideCSS.rel = 'stylesheet';
  glideCSS.href = 'https://cdn.jsdelivr.net/npm/@glidejs/glide/dist/css/glide.core.min.css';
  document.head.appendChild(glideCSS);

  const glideThemeCSS = document.createElement('link');
  glideThemeCSS.rel = 'stylesheet';
  glideThemeCSS.href = 'https://cdn.jsdelivr.net/npm/@glidejs/glide/dist/css/glide.theme.min.css';
  document.head.appendChild(glideThemeCSS);

  // Load GlideJS script dynamically
  function loadScript(src, callback) {
    const script = document.createElement('script');
    script.src = src;
    script.onload = callback;
    document.body.appendChild(script);
  }

  loadScript('https://cdn.jsdelivr.net/npm/@glidejs/glide/dist/glide.min.js', function () {
    function initGlide(selector) {
      if (window.innerWidth <= 768) {
        new Glide(selector, {
          type: 'carousel',
          perView: 1,
          gap: 20,
          focusAt: 'center',
        }).mount();
      }
    }

    initGlide('.custom-glide-1');
    initGlide('.custom-glide-2');

    // Optional: Re-init slider on window resize
    window.addEventListener('resize', function () {
      if (window.innerWidth <= 768) {
        document.querySelectorAll('.custom-glide').forEach((glideEl) => {
          if (glideEl._glide) {
            glideEl._glide.destroy();
            new Glide(glideEl, {
              type: 'carousel',
              perView: 1,
              gap: 20,
              focusAt: 'center',
            }).mount();
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
